<div class="modal-content">
  <div class="modal-header">
    <label class="modal-title text-text-bold-900" id="myModalLabel33"><b>Etiket Bilgileri</b></label>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
 
    <div class="modal-body">

      <div class="row">
        <div class="col-md-12">
          <div class="etiket">
            <div class="ust">
                <span>Hasta Ad Soyad</span>
                <span>01.01.2025</span>
            </div>
            <div class="icerik">
                <p><b>{{label?.drugLabelInformation?.drugName}}</b> <span style="float:right;"><b>Bitiş Tarihi:</b> 01.01.2025</span></p>
                <p>{{label?.drugLabelInformation?.usagePurpose}}</p>
        
                <p><b>KULLANIM:</b><br>
               {{label?.drugLabelInformation?.usageInstructions}}
                </p>
        
                <div class="uyarilar">
                    <b>UYARILAR:</b>
                    <ul>
                        <li *ngFor="let u of label?.drugLabelInformation?.warnings">{{u}}</li>
                       
                    </ul>
                </div>
            </div>
            <div class="alt">
                <span>XXXXXX ECZANESİ (555) 555 55 55</span>
                
            </div>
        </div>
        </div>
      </div>

      

    <div class="row">
      <div class="col-md-12">
        <div class="iphone-frame">
          <div class="notch"></div>
      
          <h1>{{label?.patientMobileAppDrugInformation?.drugName}}</h1>
      
          <div class="image-box">
              <img src="assets/images/ilac.png" alt="">
          </div>
      
          <div class="section">
              <span class="icon">💉</span>
              <b>İlaç Adı:</b>{{label?.patientMobileAppDrugInformation?.drugName}}
          </div>
      
          <div class="section">
              <span class="icon">⚗️</span>
              <b>Etken Madde:</b> <ul>
                <li *ngFor="let u of label?.patientMobileAppDrugInformation?.activeIngredients">{{u.name}} {{u.amunt}}</li>
               
            </ul>
          </div>
      
          <div class="section">
              <span class="icon">❄️</span>
              <b>Endikasyon:</b> {{label?.patientMobileAppDrugInformation?.indications}}
          </div>
      
          <div class="section">
              <span class="icon">⏱️</span>
              <b>Doz Talimatı:</b> 
              {{label?.patientMobileAppDrugInformation?.dosageInstructions?.adults}}<br/>
              {{label?.patientMobileAppDrugInformation?.dosageInstructions?.maximumDailyDose}}
          </div>
      
          <div class="section">
              <span class="icon">❗</span>
              <b>Uyarılar:</b>
              <ul>
                  <li *ngFor="let u of label?.patientMobileAppDrugInformation?.warnings">{{u}}</li>
                 
              </ul>
          </div>
      
          <div class="section">
              <span class="icon">🚫</span>
              <span class="warning">Yutulmaz.</span> 
              
              {{label?.patientMobileAppDrugInformation?.administrationMethodNote}}
          </div>
      </div>
      </div>
    </div>



      
      
    </div>

    <div class="modal-footer">
      <button type="reset" class="btn grey btn-outline-secondary btn-lg"
        (click)="close()">Kapat</button>
      <button type="button" class="btn btn-primary btn-lg" (click)="Accept()" [disabled]="submitted">
        <i class="fa fa-refresh fa-spin" *ngIf="submitted"></i>
        Onayla</button>
    </div>

</div>